<block-ui name="block-ui-main" [delayStart]="200" [delayStop]="200">
  <kvb-kontoverbindungen></kvb-kontoverbindungen>
</block-ui>
